export const clickSignTypes = {
    IMAGE_AUTHORIZATION: "AUTORIZACAO_IMAGEM",
};
